import React from "react";
import Header from "../../components/Header";
import ServiceRow from "../../components/ServiceRow";
import Firebase from "../../firebasehelper";
import AddServiceModal from "./components/AddServiceModal";
import AddTier2 from "./components/AddTier2";
import mobile_pad_logo from "../../assets/media/photos/social.png";
import "./index.css";
class Chatbots extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      brand_name: "",
      brand_url: "",
      services_routing: [],
      brands: [],
    };
  }
  async componentDidMount() {
    if (!this.props.location.state) {
      this.props.history.push("/");
    } else {
      const { brand, role, username } = this.props.location.state;
      this.setState({ username, role, brand, loading: true });
      console.log("role", role);
      Firebase.getAllBrands((res) => {
        this.setState({ brands: res });
      });
      let result = await this.getServicesRouting();
      this.setState({ services_routing: result, loading: false });
    }
  }
  getTier2DatafromTier2 = (tier2) => {
    if (tier2) {
      let tier2_promise = tier2.map(async (item) => {
        let category_data = await Firebase.getCategorybyID(item.id);
        console.log("tier2", tier2);
        const { topic, image } = category_data;
        if (item.id === 0)
          return {
            id: 0,
            title: "Home Emergency",
            src: image,
            active: item.active,
          };
        else if (item.id === 1)
          return {
            id: 1,
            title: "Home Repairs",
            src: image,
            active: item.active,
          };
        else
          return { id: item.id, title: topic, src: image, active: item.active };
      });
      return Promise.all(tier2_promise);
    }
  };
  toggleTier1 = (index) => {
    let { services_routing } = this.state;
    let active = services_routing[index].active;
    let is_brandRouting = services_routing[index].is_brandRouting;
    services_routing[index].active = !active;
    if (services_routing[index].active) {
      let tier2_arr = services_routing[index].value;
      services_routing[index].value = tier2_arr.map((item) => {
        item.active = true;
        return item;
      });
    } else {
      let tier2_arr = services_routing[index].value;
      services_routing[index].value = tier2_arr.map((item) => {
        item.active = false;
        //item.is_brandRouting = is_brandRouting;
        return item;
      });
    }
    this.setState({ services_routing });
    this.save();
  };
  toggleTier2 = (tier1_index, tier2_index) => {
    let { services_routing } = this.state;
    let active = services_routing[tier1_index].value[tier2_index].active;
    services_routing[tier1_index].value[tier2_index].active = !active;
    this.setState({ services_routing });
    this.save();
  };
  showServicesRouting = () => {
    const { services_routing } = this.state;
    return services_routing.map((item, index) => {
      const { is_brandRouting } = item;
      return (
        <div style={{ display: "flex" }}>
          <ServiceRow
            index={index}
            service={item}
            toggleTier1={() => this.toggleTier1(index)}
            toggleTier2={(tier2_index) => this.toggleTier2(index, tier2_index)}
          />
          {is_brandRouting && (
            <button
              className="btn btn-secondary add"
              data-toggle="modal"
              data-target="#add_Tier2"
              onClick={() => this.setState({ selectedIndex: index })}
            >
              +Add
            </button>
          )}
        </div>
      );
    });
  };
  getServicesRouting = async () => {
    let services_routing = await Firebase.getGlobalServicesRouting();
    this.setState({ services_routing });
    let promise = services_routing.map(async (item, index) => {
      let tier1 = item.tier1;
      let tier2 = item.tier2;

      if (tier2 == null) {
        let tier1_data = await Firebase.getTier1byID(tier1.id);
        let data = tier1_data;
        data["value"] = [];
        data.is_brandRouting = item.is_brandRouting;
        data.active = tier1.active;
        data.id = tier1.id;
        return data;
      } else {
        let tier1_data;
        tier1_data = await Firebase.getTier1byID(tier1.id);

        let tier2_data = await this.getTier2DatafromTier2(tier2);
        const { title, src } = tier1_data;
        let data = { title: title, src: src };
        data["value"] = tier2_data;
        data.active = tier1.active;
        data.is_brandRouting = item.is_brandRouting;
        data.id = tier1.id;
        return data;
      }
    });
    return Promise.all(promise);
  };
  save = () => {
    this.setState({ loading: true });
    let { services_routing, brands } = this.state;
    console.log("pre services_routing", services_routing);
    //console.log("brands", brands);
    let global_routing = services_routing.map((item) => {
      let new_item = { tier1: {}, tier2: {} };
      if (item.is_brandRouting) new_item.is_brandRouting = item.is_brandRouting;
      new_item.tier1.active = item.active;
      new_item.tier1.id = item.id;
      let tier2 = item.value;
      tier2 = tier2.map((tier) => {
        let newtier2 = {};
        newtier2.id = tier.id;
        newtier2.active = tier.active;
        return newtier2;
      });
      new_item.tier2 = tier2;
      return new_item;
    });
    //save to firebase database chatbot/services_routing
    Firebase.updateGlobalService(global_routing);

    services_routing = services_routing.map((item) => {
      let new_item = { tier1: {}, tier2: {} };
      if (item.is_brandRouting) new_item.is_brandRouting = item.is_brandRouting;
      if (item.active) {
        new_item.tier1.active = item.active;
        new_item.tier1.id = item.id;

        let tier2 = item.value;
        tier2 = tier2.map((tier) => {
          let newtier2 = {};
          if (tier.active) {
            newtier2.id = tier.id;
            newtier2.active = tier.active;
            return newtier2;
          }
        });
        new_item.tier2 = tier2;
        return new_item;
      }
    });
    services_routing = this.filterArray(services_routing);
    //console.log("services_routing", services_routing);
    brands.map((item, index) => {
      let brand_services_routing = item.services_routing;
      console.log("index,item", index, item);
      let brand_routing_array = [];
      brand_services_routing.forEach((obj) => {
        if (obj.is_brandRouting) brand_routing_array.push(obj);
      });
      let final_service_routing = services_routing.concat(brand_routing_array);
      console.log("final_service_routing", final_service_routing);
      Firebase.updateBrandDataById(index, {
        services_routing: final_service_routing,
      });
    });
    this.setState({ loading: false });
  };
  filterArray = (services_routing) => {
    let array = [];
    services_routing.forEach((item) => {
      if (item) {
        let obj = item;
        let tier2 = obj.tier2;
        let tier2_array = [];
        tier2.forEach((tier) => {
          if (tier) tier2_array.push(tier);
        });
        item.tier2 = tier2_array;
        array.push(item);
      }
    });
    return array;
  };
  addService = async (
    tier1_img_url,
    tier2_img_url,
    tier1_title,
    tier2_title
  ) => {
    const { brand, routings } = this.state;
    let new_servicerouting = routings;
    Firebase.addTier1(tier1_img_url, tier1_title).then((res) => {
      let tier1_id = res;
      Firebase.addNewCategory(tier2_img_url, tier2_title).then((result) => {
        let category_id = result;
        const newObj = {
          tier1: { active: true, id: tier1_id },
          tier2: [{ active: true, id: category_id }],
          is_brandRouting: true,
        };
        new_servicerouting.push(newObj);
        console.log("new_servicerouting", new_servicerouting);
        Firebase.updateBrandDataById(brand, {
          services_routing: new_servicerouting,
        });
      });
      console.log("Tier1 id added", res);
    });
  };
  addTier2 = async (tier2_img_url, tier2_title) => {
    const { brand, routings, selectedIndex } = this.state;
    let new_servicerouting = routings;
    console.log("selectedIndex", selectedIndex);
    Firebase.addNewCategory(tier2_img_url, tier2_title).then((result) => {
      let category_id = result;
      const newObj = { active: true, id: category_id };
      new_servicerouting[selectedIndex].tier2.push(newObj);
      console.log("new_servicerouting", new_servicerouting);
      Firebase.updateBrandDataById(brand, {
        services_routing: new_servicerouting,
      });
    });
  };
  render() {
    const { username, role, logo, brand, brand_name, loading } = this.state;
    return (
      <div id="page-container">
        <Header
          username={username}
          role={role}
          logo={logo}
          brand={brand}
          brandName={brand_name}
        />
        <main id="main-container">
          <div className="heading">
            <h4>Please note these routings control brand chat bot routings.</h4>
          </div>
          <div className="services-content">
            {!loading ? (
              this.showServicesRouting()
            ) : (
              <div className="loading-bar">
                <i className="fa fa-4x fa-sync fa-spin text-muted" />
              </div>
            )}
          </div>

          <button
            className="btn btn-secondary add"
            data-toggle="modal"
            data-target="#add_service"
          >
            +Add
          </button>

          <AddServiceModal addService={this.addService} />
          <AddTier2 addService={this.addTier2} />
        </main>
      </div>
    );
  }
}
export default Chatbots;



// WEBPACK FOOTER //
// ./src/screens/super_chatbots/index.js